export default {
  sliders: [
    {
      name: 'discount',
      type: 'string'
    }
  ]
}
